import { api } from './client'

/**
 * F-162 (residuo g): client di `UserDepartmentsController` (`/api/user-departments`) — i rami degli utenti per la
 * Libreria. Solo Admin (gli altri ricevono 403). Nessun importo e nessun dato del cliente: id e conteggi.
 */
export interface UserDepartmentDepartment {
  id: number
  name: string
  isActive: boolean
}

export interface UserDepartmentAssignment {
  departmentId: number
  source: 'manual' | 'proposal'
}

export interface UserDepartmentProposal {
  departmentId: number
  contracts: number
}

/** F-165: rami che l'utente ha dal profilo agente o dalle assegnazioni provvigionali (sola lettura). */
export interface UserDepartmentOtherSource {
  departmentId: number
  source: 'agent_profile' | 'commission_assignment'
}

export interface UserDepartmentUser {
  userId: number
  name: string
  role: string
  departmentIds: number[]
  assignments: UserDepartmentAssignment[]
  proposed: UserDepartmentProposal[]
  otherSources?: UserDepartmentOtherSource[]
}

export interface UserDepartmentsResponse {
  months: number
  /** F-165: quanti utenti e rami aggiungerebbe adesso "Applica la proposta". */
  proposalSummary?: { users: number; departments: number }
  departments: UserDepartmentDepartment[]
  users: UserDepartmentUser[]
}

export const userDepartmentsApi = {
  list: (months = 12) => api<UserDepartmentsResponse>(`/api/user-departments?months=${months}`),
  set: (userId: number, departmentIds: number[]) =>
    api<{ userId: number; departmentIds: number[]; added: number; removed: number }>(
      `/api/user-departments/${userId}`,
      { method: 'PUT', body: JSON.stringify({ departmentIds }) }),
  applyProposal: (userIds?: number[], months = 12) =>
    api<{ users: number; added: number }>(
      `/api/user-departments/apply-proposal?months=${months}`,
      { method: 'POST', body: JSON.stringify({ userIds: userIds ?? null }) }),
}
